import React, { useState } from 'react';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import { ADMIN_MENU, USER_MENU, OPERADOR_MENU } from '../../constants/sidebarOptions';
import { useAuthentication } from '../../hooks/useAuthentication';
import { Button, IconButton, Menu, MenuItem, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { getRoleText } from '../../utils/getRoleText';
import { logout } from '../../context/redux/slicers/authSlice';
import { useDispatch } from 'react-redux';
import MenuIcon from '@mui/icons-material/Menu';

export default function MenuDrawer() {
  const isXs = window.innerWidth < 600;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { userRole, userName, isAuthenticated } = useAuthentication();
  const [open, setOpen] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const openMenu = Boolean(anchorEl);

  const toggleDrawer = (newOpen) => () => {
    setOpen(newOpen);
  };

  const handleListItemClick = (event, index) => {
    setSelectedIndex(index);
  };

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleLogout = () => {
    dispatch(logout());
  };

  const getMenuOptions = () => {
    switch (userRole) {
      case 'Administrador':
        return ADMIN_MENU;
      case 'operador':
        return OPERADOR_MENU;
      case 'user':
        return USER_MENU;
      default:
        return [];
    }
  };

  const DrawerList = (
    <Box
      role="presentation"
      onClick={toggleDrawer(false)}
      sx={{
        width: 350,
        height: '100%',
        backgroundImage: 'linear-gradient(180deg, #3A0C18 0%, #4A1121 25%, #591629 50%, #591629 75%, #691B32 100%)',
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'flex-start',
      }}
    >
      <Box
        sx={{
          backgroundImage: 'url(/images/logos/logo-blanco-h.png)',
          backgroundSize: 'contain',
          backgroundRepeat: 'no-repeat',
          height: 100,
          width: '100%',
          display: 'flex',
        }}
      />
      <Typography
        variant='h6'
        color='primary.gold'
      >
        {getRoleText(userRole)}
      </Typography>
      <List
        sx={{
          color: 'primary.white'
        }}
      >
        {getMenuOptions().map((item) => (
          <ListItem
            key={item.text}
            onClick={() => {
              navigate(item.route);
              handleListItemClick(null, item.text);
            }}
            selected={selectedIndex === item.text}
            sx={{
              color: 'white',
              '&:hover': {
                backgroundColor: 'rgba(255, 255, 255, 0.1)',
              },
            }}
          >
            <ListItemIcon color='white' sx={{ color: 'white' }}>
              {item.icon}
            </ListItemIcon>
            <ListItemText primary={item.text} />
          </ListItem>
        ))}
      </List>
    </Box>
  );

  return (
    <Box
      sx={{
        position: 'sticky', // Fijo en la parte superior
        top: 0,
        left: 0,
        right: 0,
        zIndex: 1200, // Para que esté encima de otros elementos
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        backgroundColor: '#691B32',
        width: '100%',
        height: 80,
        px: 2,
      }}
    >
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          justifyContent: 'center',
          alignItems: 'center',
          py: 2,
        }}
      >
        {
          userRole === 'Administrador' ?
            <IconButton
              size='large'
              sx={{
                color: 'primary.white',
              }}
              onClick={toggleDrawer(true)}
            >
              <MenuIcon />
            </IconButton>
            : null
        }
        <Box
          sx={{
            backgroundImage: 'url(/images/logos/brigadaBlanco.png)',
            backgroundSize: 'contain',
            backgroundRepeat: 'no-repeat',
            height: isXs ? 50 : 60,
            width: isXs ? 50 : 130,
            display: 'flex',
            mr: 2,
          }}
        />
        {!isXs && (
          <Typography
            variant='h6'
            color='primary.white'
          >
            Brigada de Salud - {getRoleText(userRole)}
          </Typography>
        )}
        {!isXs && (
          <Box
            sx={{
              backgroundImage: 'url(/images/logos/oficialia_bco.svg)',
              backgroundSize: 'contain',
              backgroundRepeat: 'no-repeat',
              height: 50,
              width: 130,
              display: 'flex',
              ml: 2,
            }}
          />
        )}
      </Box>
      <Button
        id="basic-button"
        aria-controls={openMenu ? 'basic-menu' : undefined}
        aria-haspopup="true"
        aria-expanded={openMenu ? 'true' : undefined}
        onClick={handleClick}
        sx={{
          color: 'primary.white',
          fontWeight: 'bold',
          textTransform: 'none',
        }}
      >
        {userRole ? userRole + ' - ' : ''} {userName || 'Ingresar'}
      </Button>

      <Menu
        id="basic-menu"
        anchorEl={anchorEl}
        open={openMenu}
        onClose={handleClose}
        MenuListProps={{
          'aria-labelledby': 'basic-button',
        }}
      >
        {
          isAuthenticated ? (
            <MenuItem onClick={handleLogout}>Cerrar Sesión</MenuItem>
          ) : (
            <MenuItem onClick={() => navigate('/login')}>Iniciar Sesión</MenuItem>
          )
        }
      </Menu>

      <Drawer
        anchor="left"
        open={open}
        onClose={toggleDrawer(false)}
        sx={{
          zIndex: 1201, // Asegura que el Drawer esté encima de otros elementos
        }}
        ModalProps={{
          keepMounted: true, // Mejora el rendimiento cuando el Drawer está cerrado
        }}
      >
        {DrawerList}
      </Drawer>
    </Box>
  );
}
